module.exports = require("@workbench-stack/configuration");